<ng-container>
  <ion-header class="ion-hide-lg-down">
    <ion-toolbar>
    </ion-toolbar>
  </ion-header>
  <!--  avatar block-->
  <div class="menu-top ion-padding-vertical">
    <ion-item lines="none" (click)="menuService.closeMenu()">
      <ion-icon name="menu-outline" class="ion-padding-horizontal"></ion-icon>
    </ion-item>

    <ng-container *ngIf="auth.isLogin$|async">
      <ng-container *ngIf="(menuService.menuItemsSettings$| async) as menuItemsSettings">
        <ion-avatar (click)="menuService.openPage(menuItemsSettings[1])" class="profile"
                    [ngStyle]="{ 'background-image': 'url(' + api.data.current.photo + ')'}"></ion-avatar>

        <div (click)="menuService.openPage(menuItemsSettings[2])"
             class="username">{{ api.data.current.username }}</div>
      </ng-container>
    </ng-container>
  </div>
  <!--    end avatar block-->

  <!--      main outlet - most menu items will render here-->
  <ng-container *ngFor="let menu_item of menuService.menuItems$ |async">
    <!--        stats (and settings) go at the end)-->
    <ng-container *ngIf="menu_item._id !== 'stats'">
      <ion-item *ngIf="(menu_item._id == 'subscribe' && !(auth.isPaying$|async)) || menu_item._id != 'subscribe'"
                (click)="menuService.openPage(menu_item)">
        <ng-container *ngIf=" menu_item.icon!='';else notIoniconIcon">
          <ion-icon name="{{menu_item.icon}}" class="ion-padding-horizontal"></ion-icon>
        </ng-container>
        <ng-template #notIoniconIcon>
          <ion-icon [src]="'assets/icon/'+ menu_item._id + '.svg'"
                    class="ion-padding-horizontal"></ion-icon>
        </ng-template>
        <ion-label class="ion-padding-start">{{menu_item.title}}</ion-label>
        <div class="badge" *ngIf="((auth.isLogin$|async) && menu_item.count != 0)">{{ menu_item.count}}
        </div>
      </ion-item>
    </ng-container>
  </ng-container>
  <!--    lists and settings-->
  <ng-container *ngIf="auth.isLogin$|async">
    <ion-accordion-group expand="compact">
      <ion-accordion value="lists">
        <ion-item slot="header">
          <ion-icon name="stats-chart" class="ion-padding-horizontal"></ion-icon>
          <ion-label class="ion-padding-start">רשימות</ion-label>
        </ion-item>
        <ion-list slot="content">
          <ion-item *ngFor="let menu_item of menuService.menuItemsContacts$|async"
                    (click)="menuService.openPage(menu_item)">
            <ng-container *ngIf="menu_item.icon!='';else notIoniconIcon">
              <ion-icon name="{{menu_item.icon}}" class="ion-padding-horizontal"></ion-icon>
            </ng-container>
            <ng-template #notIoniconIcon>
              <ion-icon [src]="'assets/icon/' + menu_item._id + '.svg'"
                        class="ion-padding-horizontal"></ion-icon>
            </ng-template>
            <ion-label class="ion-padding-start">{{menu_item.title}}</ion-label>
            <div class="badge" *ngIf=" menu_item.count != 0">{{ menu_item.count}}</div>
          </ion-item>
        </ion-list>
      </ion-accordion>
      <ion-accordion value="settings">
        <ion-item slot="header">
          <ion-icon name="settings-outline" class="ion-padding-horizontal"></ion-icon>
          <ion-label class="ion-padding-start">החשבון שלי</ion-label>
        </ion-item>
        <ion-list slot="content">
          <ion-item *ngFor="let menu_item of menuService.menuItemsSettings$|async"
                    (click)="menuService.openPage(menu_item)">
            <ng-container *ngIf="menu_item.icon!='';else notIoniconIcon">
              <ion-icon name="{{menu_item.icon}}" class="ion-padding-horizontal"></ion-icon>
            </ng-container>
            <ng-template #notIoniconIcon>
              <ion-icon [src]="'assets/icon/'+ menu_item._id + '.svg'"
                        class="ion-padding-horizontal"></ion-icon>
            </ng-template>
            <ion-label class="ion-padding-start">{{menu_item.title}}</ion-label>
            <div class="badge" *ngIf=" menu_item.count != 0">{{ menu_item.count}}</div>
          </ion-item>
        </ion-list>
      </ion-accordion>
    </ion-accordion-group>
  </ng-container>
  <!--      end menu outlet-->
  <div class="ion-text-center">
    <ion-button href="https://www.instagram.com/richdate_official/" target="_blank" shape="round" size="large"
                fill="clear">
      <ion-icon slot="icon-only" name="logo-instagram" color="light"></ion-icon>
    </ion-button>
  </div>
</ng-container>
